import { useState } from 'react';
import type { PortfolioItemWithUrl } from '../../../hooks/usePortfolioStore';

interface Props {
  items: PortfolioItemWithUrl[];
  onClickItem: (index: number) => void;
}

export default function PhotoGrid({ items, onClickItem }: Props) {
  const [hovered, setHovered] = useState<string | null>(null);

  return (
    <div className="columns-1 sm:columns-2 lg:columns-3 gap-1">
      {items.map((item, idx) => (
        <div
          key={item.id}
          className="break-inside-avoid mb-1 relative overflow-hidden cursor-pointer"
          onClick={() => onClickItem(idx)}
          onMouseEnter={() => setHovered(item.id)}
          onMouseLeave={() => setHovered(null)}
        >
          <img
            src={item.imageUrl}
            alt=""
            className="w-full h-auto object-cover block"
          />
          <div
            className={`absolute inset-0 bg-black/30 transition-opacity duration-300 flex items-center justify-center ${
              hovered === item.id ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white/20 backdrop-blur-sm">
              <i className="ri-zoom-in-line text-white text-lg" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
